export default "__VITE_ASSET__57714551__"